import { createFileRoute } from '@tanstack/react-router'
import AcceptTeamInvitationPage from '@/components/pages/AcceptTeamInvitationPage/AcceptTeamInvitationPage'

export const Route = createFileRoute('/accept-invitation')({
  component: AcceptInvitationRoute,
})

function AcceptInvitationRoute() {
  return <AcceptTeamInvitationPage />
}
